import { render, staticRenderFns } from "./CashmereLongImage.vue?vue&type=template&id=8b9a8e7a&scoped=true"
import script from "./CashmereLongImage.vue?vue&type=script&lang=js"
export * from "./CashmereLongImage.vue?vue&type=script&lang=js"
import style0 from "./CashmereLongImage.vue?vue&type=style&index=0&id=8b9a8e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9a8e7a",
  null
  
)

export default component.exports